<template>
  <div>
    <user-form
      @submit="updateUser"
      :source-loading="loading"></user-form>
  </div>
</template>

<script>
import { User } from '@/mixins'

export default {
  name: 'ProfilInfo',
  components: {
    UserForm: () => import('@/components/users/UserForm')
  },
  mixins: [User]
}
</script>
